<template>
  <div class="collection-wrapper" v-if="ready">
    <div class="collection-header">
      <div class="header-title-wrapper">
        <div class="header-title">{{ collectionData.title }}</div>
        <div class="collection-author">
          <vs-avatar
            size="42"
            history
            history-gradient
            @click="handleUserPage(collectionData.user.username)"
            pointer
          >
            <img :src="collectionData.user.profile_image.medium" alt />
          </vs-avatar>
          <span @click="handleUserPage(collectionData.user.username)">
            {{ collectionData.user.first_name }}
            {{ collectionData.user.last_name }}
          </span>
        </div>
      </div>

      <div
        class="header-bg"
        :style="{
          backgroundImage: 'url(' + collectionData.cover_photo.urls.raw + ')',
        }"
      ></div>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 1440 320"
        class="svg-wave"
      >
        <path
          fill="#f5f5f5"
          fill-opacity="1"
          d="M0,128L48,138.7C96,149,192,171,288,165.3C384,160,480,128,576,128C672,128,768,160,864,192C960,224,1056,256,1152,266.7C1248,277,1344,267,1392,261.3L1440,256L1440,320L1392,320C1344,320,1248,320,1152,320C1056,320,960,320,864,320C768,320,672,320,576,320C480,320,384,320,288,320C192,320,96,320,48,320L0,320Z"
        />
      </svg>
    </div>
    <div class="collection-body">
      <stack :column-min-width="220" :gutter-height="10" monitor-images-loaded>
        <stack-item
          v-for="(image, i) in collectionPhotos"
          :key="i"
          style="transition: transform 300ms"
        >
          <img
            class="image-wrapper"
            :src="image.urls.thumb"
            :alt="image.alt_description"
            @click="handlePhotoPage(image.id)"
          />
        </stack-item>
      </stack>
    </div>
  </div>
</template>

<script>
  import { Stack, StackItem } from "vue-stack-grid";

  export default {
    name: "CollectionPage",
    components: {
      Stack,
      StackItem,
    },
    data() {
      return {
        collectionPhotos: [],
        collectionData: [],
        ready: false,
      };
    },
    methods: {
      handlePhotoPage(id) {
        this.$router.push(`/photo/${id}`);
      },
      handleUserPage(username) {
        this.$router.push(`/user/${username}`);
      },
      getCollectionPhotos() {
        this.$http
          .get(`/collections/${this.$route.params.id}/photos?per_page=20`)
          .then((res) => {
            this.collectionPhotos = res.data;
            this.ready = true;
          });
        this.$http.get(`/collections/${this.$route.params.id}`).then((res) => {
          this.collectionData = res.data;
          this.ready = true;
        });
      },
    },
    created() {
      this.getCollectionPhotos();
    },
  };
</script>

<style lang="scss" scoped>
  .collection-wrapper {
    width: 100%;
    height: 100vh;
    display: flex;
    flex-direction: column;

    .collection-header {
      width: 100%;
      height: 35%;
      overflow: hidden;
      position: relative;
      display: flex;
      align-items: flex-end;

      .header-bg {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-size: cover;
        background-position: center;
      }
      .header-title-wrapper {
        z-index: 10;
        margin: 2rem;
        .header-title {
          font-size: 2.3rem;
          margin-bottom: 5px;
        }
        .collection-author {
          color: #f83600;
          display: flex;
          flex-direction: row;
          align-items: center;
        }

        span {
          margin-left: 10px;
          cursor: pointer;
        }
      }

      svg {
        width: 100%;
        position: absolute;
        bottom: -25px;
      }
    }
    .collection-body {
      width: 100%;
      margin-top: 1.2rem;
    }
  }
  .vsg-container {
    align-self: center !important;
    height: 0 !important;
  }
  .image-wrapper {
    box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1),
      0 4px 6px -2px rgba(0, 0, 0, 0.05);
    cursor: pointer;
    transition: all 0.2s linear;

    &:hover {
      transform: scale(1.1);
      z-index: 10;
      filter: brightness(0.7);
    }
  }
</style>
